import React, { useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import EditIcon from '../../Icons/EditIcon';
import { RICH, RICHTEXT } from './MetaTypes';

export function ModalInput({
  component,
  header,
  showFooter,
  showModal,
  setShowModal,
  intl,
  userInput,
  error,
  validateInput,
  hasTriedSubmitting,
  type,
}) {
  const handleClose = () => {
    setShowModal(false);
  };
  const handleShow = () => setShowModal(true);

  //Effect to validate user input on submit
  useEffect(() => {
    if (hasTriedSubmitting > 0)
      validateInput(userInput, type == RICHTEXT ? false : true);
  }, [hasTriedSubmitting]);

  //Effect to validate user input on submit
  useEffect(() => {
    validateInput(userInput, type == RICHTEXT ? false : true);
  }, [userInput]);

  return (
    <>
      <Button
        variant="primary"
        onClick={handleShow}
        className="photo-uploader__image-list-Modal-edit-button"
      >
        <EditIcon fill="white" /> <FormattedMessage id="metaInput.editField" />
      </Button>
      {error && <div className="error-message">{error}</div>}
      <Modal
        show={showModal}
        onHide={handleClose}
        dialogClassName="photo-uploader__image-list-Modal-dialog"
      >
        <Modal.Header>
          <Modal.Title>{header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="photo-uploader__image-list-Modal-content">
          {component}
        </Modal.Body>
        {showFooter && (
          <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
              <FormattedMessage id="general.save" />
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}
